module.exports = new __parcel__URL__("battlepass_present.60f072cf.png").toString();